module.exports = __webpack_public_path__ + "static/media/text_box1.2ac304cf.png";